export type PrintType = "print:1" | "print:2" | "print:3";
export type OrderTableType = "Table Type:1" | "Table Type:2";
export type BusinessOperationType = "Day" | "Shift";
export type BillResetPeriod = "noreset" | "day" | "week" | "month" | "year";

export interface PrintSettings {
  printType: PrintType;
  orderTableType: OrderTableType;
  isDualCopy: boolean;
  printProductLimit: string;
}

export interface TableBillingSettings {
  tableRows: number;
  billNoEnabled: boolean;
  billNo: BillResetPeriod;
  deliveryFeeEnabled: boolean;
  orderIdEnabled: boolean;
  customBusinessName?: string;
}

export interface TermsConditionsSettings {
  addTC: boolean;
  tcEnglish: string;
  tcArabic: string;
}

export interface QRSettings {
  contactQR: {
    file: File | null;
    preview: string;
  };
  locationQR: {
    file: File | null;
    preview: string;
  };
}

export interface ReportsSettings {
  pdfProductLimit: string;
  showOutstanding: boolean;
}

export interface FoodTypesSettings {
  foodTypes: string[];
}

export interface BusinessOperationSettings {
  businessOperationEnable: boolean;
  businessOperationType: BusinessOperationType;
  shiftTypes: string[];
}

export interface HomepageSettings {
  isDefaultTabsEnabled: boolean;
  isProductsNotesEnabled: boolean;
}

export interface PrinterSettings {
  appPrinterEnabled: boolean;
  selectedPrinters: string[];
}

export interface ConfigurationState
  extends PrintSettings,
    TableBillingSettings,
    TermsConditionsSettings,
    QRSettings,
    ReportsSettings,
    FoodTypesSettings,
    BusinessOperationSettings,
    HomepageSettings,
    PrinterSettings {
  businessName: string;
}

export const DEFAULT_FOOD_TYPES = ["Veg", "Non-Veg"];
export const DEFAULT_SHIFT_MANAGE = ["Morning Shift", "Evening Shift"];
export const MAX_TYPES = 5;

export const dropDownValue = [
  { _id: "10", CategoryName: "10" },
  { _id: "25", CategoryName: "25" },
  { _id: "50", CategoryName: "50" },
  { _id: "100", CategoryName: "100" },
  { _id: "250", CategoryName: "250" },
  { _id: "500", CategoryName: "500" },
];

export const billNoDropDownValue = [
  { _id: "noreset", CategoryName: "No reset" },
  { _id: "day", CategoryName: "Day" },
  { _id: "week", CategoryName: "Week" },
  { _id: "month", CategoryName: "Month" },
  { _id: "year", CategoryName: "Year" },
];